import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from '../views/components/Sidebar';
import Topbar from '../views/components/Topbar';
import Pagination from '../views/components/Pagination';
import { getDeacomConfirmations } from '../data/dataApi';

const listLimit = 100;

const formatDateTime = value => {
    if (!value) return '—';
    const date = new Date(value);
    if (isNaN(date)) return value;
    return date.toLocaleString('en-US', {
        month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
    });
};

const DeacomConfirmations = () => {
    const { page } = useParams();
    const [confirmations, setConfirmations] = useState([]);

    useEffect(() => {
        (async () => {
            const response = await getDeacomConfirmations(page === undefined ? 0 : page - 1);
            if (response.success) setConfirmations(response.data.rows);
        })();
        window.scrollTo(0, 0);
    }, [page]);

    return (
        <div id="pdf-order-parser" className="d-flex confirmations-page">
            <Sidebar />
            <div className="flex-grow-1">
                <Topbar title="Deacom Confirmations" backButton />
                <div className="content-wrapper wrapper tif-pt-md-50 tif-pt-25 tif-px-md-60 tif-px-30 tif-pb-85 tif-pb-45">
                    <div className="tif-mb-10">
                        <h4 className="tif-mb-5">Confirmations</h4>
                        <p className="tif-font-sm tif-color-oscar tif-mb-0">Order confirmations ingested from Deacom's eComm-Confirm feed.</p>
                    </div>

                    <div className="submissions-table-wrapper tif-mb-20">
                        <table className="submissions-table w-100">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Web Order ID</th>
                                    <th>Deacom SO Number</th>
                                    <th>Filename</th>
                                    <th>Line Items</th>
                                    <th>Confirmed At</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    confirmations.length === 0 ?
                                        <tr>
                                            <td colSpan="6" className="text-center tif-color-oscar tif-py-30">No confirmations yet.</td>
                                        </tr>
                                    :
                                        confirmations.map((row, index) => (
                                            <tr key={row.id}>
                                                <td className="tif-color-oscar" data-label="#">{(page === undefined ? 0 : (page - 1) * listLimit) + index + 1}</td>
                                                <td className="order-id-cell" data-label="Web Order ID">{row.web_order_id}</td>
                                                <td className="order-id-cell" data-label="Deacom SO Number">{row.deacom_so_number || '—'}</td>
                                                <td data-label="Filename">{row.filename}</td>
                                                <td data-label="Line Items">{row.line_item_count}</td>
                                                <td className="tif-color-oscar" data-label="Confirmed At">{formatDateTime(row.confirmed_at)}</td>
                                            </tr>
                                        ))
                                }
                            </tbody>
                        </table>
                    </div>

                    <Pagination listLength={confirmations.length && confirmations[0].total_count} path="/pdf-order-parser/deacom-confirmations" page={page} limit={listLimit} />
                </div>
            </div>
        </div>
    );
};

export default DeacomConfirmations;
